import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import CustomerInquiryHistory from './CustomerInquiryHistory';
import CustomerInquiryEditor from './CustomerInquiryEditor';
import {connect} from 'react-redux';
import CustomerInquiryDetail from './CustomerInquiryDetail';
import {PageContainer, PageDescription, PageTitle} from '../../Common/PageComponents';
import MessageBox from '../../Common/MessageBox';

const stateToProps = state => {
  return {
    userName: state.user.username,
  };
};

class CustomerInquiry extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title={'1:1 문의'} />
        <PageDescription>
          궁금하신 사항을 시원하게 해결해 드리겠습니다. <br />
          FAQ에서도 궁금증이 해결되지 않으셨다면 1:1문의를 통해 해결할 수 있습니다.
        </PageDescription>
        <MessageBox style={{margin: '30px 0'}}>
          고객센터 1688-1011 (FAX 번호: 02-863-4850) <br />
          운영시간 : 24시간 운영 <br />
          E-mail 주소: <a href="mailto:lol@sonokongib.co.kr">lol@sonokongib.co.kr</a>
        </MessageBox>
        <Route exact path="/customer/inquiries" component={CustomerInquiryHistory} />
        <Route exact path="/customer/inquiries/submission" component={CustomerInquiryEditor} />
        <Route exact path="/customer/inquiries/detail/:id" component={CustomerInquiryDetail} />
      </PageContainer>
    );
  }
}

export default withRouter(connect(stateToProps)(CustomerInquiry));
